module.exports = __webpack_public_path__ + "static/banner-dfdbb3c8d10692543556f660f79809b5.png";